@charset "UTF-8";

/* src/app/modules/institutions/institutions-openinghours/institutions-openinghours.component.scss */
:host .cw-submodule {
  flex: 1 0 calc(50% - 10px);
}
:host .cw-weekend-break {
  flex-basis: 100%;
}
:host .cw-weekend-break .cw-horizontalline {
  width: calc(50% - 10px);
}
:host .cw-weekend-break phscw-input-text {
  width: calc(50% - 10px);
}
:host phscw-input-time ::ng-deep .cw-time-input-wrapper {
  padding-right: 40px;
}
:host phscw-input-time ::ng-deep .cw-input-label,
:host phscw-input-date ::ng-deep .cw-input-label {
  margin-left: 5px;
  margin-right: 5px;
  min-width: 0;
  width: auto;
}
:host phscw-input-time ::ng-deep .cw-input {
  position: relative;
}
:host phscw-input-time ::ng-deep .cw-delete {
  margin: 0;
  position: absolute;
  right: 40px;
}
/*# sourceMappingURL=institutions-openinghours.component.css.map */
